<template>
  <div class="user-notification-data-list border-top">
    <UserNotificationDataListItem
      v-for="(item, index) in items"
      :key="index"
      :item="item"
    />
  </div>
</template>
<script lang="ts">
import { inject } from 'vue'
import { ModelCoreUserNotification } from '../models/ModelCoreUserNotifications'

export default {
  name: 'UserNotificationDataList',
  setup() {
    return {
      items: inject('items') as ModelCoreUserNotification[],
    }
  },
}
</script>
